'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FontIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var FontIcon = function FontIcon(_ref) {
  var alt = _ref.alt,
      children = _ref.children,
      className = _ref.className,
      theme = _ref.theme,
      value = _ref.value,
      other = _objectWithoutProperties(_ref, ['alt', 'children', 'className', 'theme', 'value']);

  return (// eslint-disable-line
    _react2.default.createElement(
      'span',
      _extends({
        'data-react-toolbox': 'font-icon',
        'aria-label': alt,
        className: (0, _classnames2.default)({ 'material-icons': typeof value === 'string' || typeof children === 'string' }, className)
      }, other),
      value,
      children
    )
  );
};

FontIcon.propTypes = {
  alt: _propTypes2.default.string,
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  theme: _propTypes2.default.object, // eslint-disable-line
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element])
};

FontIcon.defaultProps = {
  alt: '',
  className: ''
};

exports.default = FontIcon;
exports.FontIcon = FontIcon;


//////////////////
// WEBPACK FOOTER
// ./~/react-toolbox/lib/font_icon/FontIcon.js
// module id = 592
// module chunks = 39